import {
    CreateDocumentPayload, DocumentResponse, UpdateDocumentActionPayload, UpdateDocumentPayload
} from '../features/job/jobTypes';
import { get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';

// Endpoint paths
const createDocumentEndpoint = '/{0}/jobPost.create';
const updateDocumentEndpoint = '/{0}/{1}/jobPost.update';
const fetchDocumentEndpoint = '/{0}/{1}/jobPost.detail';
const fetchDocumentListEndpoint = '/{0}/jobPost.list';
const updateDocumentTagsEndpoint = '/{0}/{1}/jobPost.update';
const fetchJobPostReport = '/{0}/{1}/jobPost.report'


const credentialsConfig = {
    withCredentials: true,
};

export const createDocumentTemplate = async (payload: CreateDocumentPayload): Promise<DocumentResponse> => {
    const endpoint = formatUrl(createDocumentEndpoint, [payload.baseId]);
    return post<DocumentResponse>(
        endpoint,
        {
            job_title: payload.job_title,
            job_department_id: payload.job_department_id,
            experience_level: payload.experience_level
        },
        credentialsConfig
    );
};

// update document template
export const updateDocumentTemplate = async (payload: UpdateDocumentPayload): Promise<DocumentResponse> => {
    const endpoint = formatUrl(updateDocumentEndpoint, [payload.baseId, payload.id]);

    return put<DocumentResponse>(
        endpoint,
        {
            doc_name: payload.name,
            job_department_id: payload.job_department_id,
            job_description: payload.job_description,
            job_title: payload.job_title,
            job_location: payload.job_location,
            job_type: payload.job_type,
            job_workplace_type: payload.job_workplace_type,
            educational_requirement: payload.educational_requirement,
            experience_level: payload.experience_level,
            job_status: payload.job_status,
            job_tag: payload.job_tag,
            application_intake: payload.application_intake,
            salary_min: payload.salary_min,
            salary_max: payload.salary_max,
            salary_currency: payload.salary_currency,
            salary_duration: payload.salary_duration,
            job_note: payload.job_note,
            job_description_html: payload.job_description_html,
            salary_display: payload.salary_display

        },
        credentialsConfig
    );
};

// fetch document template 
export const fetchDocumentTemplate = async (baseId: string, id: string): Promise<DocumentResponse> => {
    const endpoint = formatUrl(fetchDocumentEndpoint, [baseId, id]);
    return get<DocumentResponse>(endpoint, credentialsConfig);
};

// fetch job list 
export const fetchJobsDataList = async (baseId: number): Promise<DocumentResponse> => {
    const endpoint = formatUrl(fetchDocumentListEndpoint, [baseId]);
    return get<DocumentResponse>(endpoint, credentialsConfig);
};


// update document template
export const updateDocumentTags = async (payload: UpdateDocumentActionPayload): Promise<DocumentResponse> => {
    const endpoint = formatUrl(updateDocumentTagsEndpoint, [payload.baseId]);

    return put<DocumentResponse>(
        endpoint,
        {
            doc_tag: payload.doc_tag,
            doc_ids: payload.doc_ids,
        },
        credentialsConfig
    );
};

export const fetchJobPostReportData = async (
    baseId: string, 
    jobId: string, 
    fromDate?: string, 
    toDate?: string
  ): Promise<DocumentResponse> => {
      let endpoint = formatUrl(fetchJobPostReport, [baseId, jobId]);
      
      // Add date parameters if they exist
      if (fromDate && toDate) {
        endpoint += `?from=${fromDate}&to=${toDate}`;
      }
      
      return get<DocumentResponse>(endpoint, credentialsConfig);
  };